import { ConstructionYearContainer } from '../../containers/advancedFilters/ConstructionYearContainer';
import { IFilter } from '../../types/filters';

export const constructionYear: IFilter = {
  component: ConstructionYearContainer,
};
